require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-bunkertreppe.json") })
        }
      }, "path---projecten-bunkertreppe");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-bunkertreppe!./.cache/json/projecten-bunkertreppe.json
// module id = 405
// module chunks = 231608221292675